/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Cost breakdown by a dimension (service or region)
 */
export interface CloudCostMgmtCostByDimension { 
    /**
     * Dimension name (service name or region name)
     */
    name: string;
    /**
     * Cost in USD
     */
    cost: number;
}

